import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMacOS } from '../../utils/isMacOS';
export class Dropdown extends Component {
  constructor(props) {
    super(props);
    const { title } = this.props;

    this.state = {
      isListOpen: false,
      title,
      selectedItem: null,
      keyword: '',
      // list,
    };

    this.searchField = React.createRef();
    this.headerRef = React.createRef();
    this.menuRef   = React.createRef();
    window.addEventListener('resize', this.updateFixedMenu, false);
    window.addEventListener('scroll', this.updateFixedMenu, true);    
    this.wrapperRef = React.createRef();
    this.handleOutsidePointer = this.handleOutsidePointer.bind(this);
    window.removeEventListener('resize', this.updateFixedMenu, false);
    window.removeEventListener('scroll', this.updateFixedMenu, true);
  }

  handleOutsidePointer(e) {
    if(!this.props.surveyQuiz)
      return;
    // Only close if open and click happens outside the dropdown wrapper
    if (!this.state.isListOpen) return;
    const wrap = this.wrapperRef.current;
    if (wrap && !wrap.contains(e.target)) this.close();
  }

  componentDidMount() {
    const { select, list } = this.props;

    if (select && list.length > 0) {
      this.selectSingleItem(select);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isListOpen } = this.state;

    setTimeout(() => {
      if (isListOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);

  if (!prevState.isListOpen && isListOpen && this.props.surveyQuiz) {
    const useCapture = true;
    const type = window.PointerEvent ? 'pointerdown' : 'mousedown';
    document.addEventListener(type, this.handleOutsidePointer, useCapture);
    window.addEventListener('resize', this.updateFixedMenu, false);
    window.addEventListener('scroll', this.updateFixedMenu, true); 
  } else if (prevState.isListOpen && !isListOpen && this.props.surveyQuiz) {
    const useCapture = true;
    document.removeEventListener('pointerdown', this.handleOutsidePointer, useCapture);
    document.removeEventListener('mousedown', this.handleOutsidePointer, useCapture);
    window.removeEventListener('resize', this.updateFixedMenu, false);
    window.removeEventListener('scroll', this.updateFixedMenu, true);
  }


  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
    if (this.props.surveyQuiz) {
    const useCapture = true;
    document.removeEventListener('pointerdown', this.handleOutsidePointer, useCapture);
    document.removeEventListener('mousedown', this.handleOutsidePointer, useCapture);
    window.removeEventListener('resize', this.updateFixedMenu, false);
    window.removeEventListener('scroll', this.updateFixedMenu, true);
  }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { list } = nextProps;

    if (JSON.stringify(list) !== JSON.stringify(prevState.list)) {
      return { list };
    }

    return null;
  }

  close = () => {
    this.setState({
      isListOpen: false,
    });
  }

  clearSelection = () => {
    const { name, title, onChange } = this.props;

    this.setState({
      selectedItem: null,
      title,
    }, () => {
      onChange(null, name);
    });
  }

  selectSingleItem = (item) => {
    const { list } = this.props;

    const selectedItem = list.find((i) => i.value === item.value);
    if(!selectedItem)
      return;
    this.selectItem(selectedItem);
  }

  selectItem = (item) => {
    const { label, value } = item;
    const { selectedItem } = this.state;
    const { name, onChange, list } = this.props;

    let foundItem;

    if (!label) {
      foundItem = list.find((i) => i.value === item.value);
    }

    this.setState({
      title: label || foundItem.label,
      isListOpen: false,
      selectedItem: item,
    }, () => selectedItem?.value !== value && onChange(item, name));
  }

  toggleList = () => {
    this.setState((prevState) => ({
      isListOpen: !prevState.isListOpen,
      keyword: '',
    }), () => {
      if (this.state.isListOpen && this.searchField.current) {
        this.searchField.current.focus();
        this.setState({
          keyword: '',
        });
      }
      // Ensure fixed positioning is applied as soon as it opens (survey only)
      if (this.state.isListOpen && this.props.surveyQuiz) {
        this.updateFixedMenu();                 // now
        requestAnimationFrame(() => {           // and after layout paints
          this.updateFixedMenu();
        });
      }

      if(this.props.scrollTo && this.state.isListOpen) {
        var list = document.querySelector('.dd-scroll-list');
        let listScrollTop;
        if(this.state.selectedItem) {
          // If value is selected show it always on top
          var top = this.state.selectedItem.value;
          listScrollTop = document.getElementById(`${this.props.name}_${top}`).offsetTop;
        } else {
          // We substract two values so that the focus element is right in the middle
          if(this.props.name === "coverage" && this.props.scrollTo) {
            listScrollTop = document.getElementById(`${this.props.name}_${this.props.scrollTo}`).offsetTop;
          } else {
            var top = this.props.scrollTo - 2;
            listScrollTop = document.getElementById(`${this.props.name}_${top}`).offsetTop;
          }
        }
        list.scrollTop = listScrollTop;
      }
    });
  }

  filterList = (e) => {
    this.setState({
      keyword: e.target.value.toLowerCase(),
    });
  }

  listItems = () => {
    const {
      id,
      searchable,
      checkIcon,
      styles,
      name
    } = this.props;
    const { listItem, listItemNoResult } = styles;
    const { keyword } = this.state;
    const {list} = this.props;
    let tempList = [...list];
    const selectedItemValue = this.state.selectedItem?.value;

    if (keyword.length) {
      tempList = list.filter((item) => item.label.toLowerCase().includes(keyword.toLowerCase()));
    }

    if (tempList.length) {
      return (
        tempList.map((item) => (
          <button
            id={`${name}_${item.value}`}
            type="button"
            className={`dd-list-item ${id}`}
            style={listItem}
            key={item.value}
            onClick={() => this.selectItem(item)}
          >
            {item.label}
            {' '}
            {item.value === selectedItemValue && (
              <span style={styles.checkIcon}>
                {/* {checkIcon || <Check />} */}
              </span>
            )}
          </button>
        ))
      );
    }

    return (
      <div
        className={`dd-list-item no-result ${id}`}
        style={listItemNoResult}
      >
        {searchable[1]}
      </div>
    );
  }


  updateFixedMenu = () => {
    const menu   = this.menuRef.current;
    const header = this.headerRef.current;
    if (!menu || !header) return;

    const { surveyQuiz } = this.props;

    if(!surveyQuiz)
      return;

    const r  = header.getBoundingClientRect();
    const vw = window.innerWidth;

    const width = r.width;
    let left = r.left;
    if (left + width > vw) left = Math.max(0, vw - width);

    // default: desktop (downward) – keep your current behavior
    let styleOverride = {
      position: 'fixed',
      width: `${width}px`,
      zIndex: '10000',
    };

    // let your CSS handle margin-top for the downward case
    menu.style.marginTop = '';

    Object.assign(menu.style, styleOverride);
  };




  render() {
    const {
      id,
      searchable,
      styles,
      titleBold,
      surveyQuiz,
      desktopSurvey
    } = this.props;
    const { isListOpen, title, selectedItem } = this.state;

    const {
      wrapper,
      header,
      headerTitle,
      list,
      listSearchBar,
      scrollList,
    } = styles;

    return (
      <div
        className={`dd-wrapper ${id} ${surveyQuiz ? "mw-100":""}`}
        style={wrapper}
        ref={this.wrapperRef}
      >
        <button
          type="button"
          className={`dd-header ${id} ${isListOpen ? "show" : ""} ${!isMacOS() && "not-mac-os"}`}
          style={header}
          onClick={this.toggleList}
          ref={this.headerRef}
        >
          <div
            className={`dd-header-title ${id} ${selectedItem && titleBold ? 'font-weight-bold':""} ${!isMacOS() && "not-mac-os"} ${surveyQuiz ? "fs-15" : ""}`}
            style={headerTitle}
          >
            {title}
          </div>
        </button>
        {isListOpen && (
          <div
            className={`dd-list${searchable ? ' searchable' : ''} ${id} ${surveyQuiz && !desktopSurvey ? "upward" : ""}`}
            style={list}
            ref={this.menuRef}
          >
            {searchable
            && (
            <input
              ref={this.searchField}
              className={`dd-list-search-bar ${id}`}
              style={listSearchBar}
              placeholder={searchable[0]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => this.filterList(e)}
            />
            )}
            <div
              className={`dd-scroll-list ${id} ${surveyQuiz ? "fs-15" : ""}`}
              style={scrollList}
            >
              {this.listItems()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Dropdown.defaultProps = {
  id: '',
  select: undefined,
  searchable: undefined,
  styles: {},
  arrowUpIcon: null,
  arrowDownIcon: null,
  checkIcon: null,
};

Dropdown.propTypes = {
  id: PropTypes.string,
  styles: PropTypes.shape({
    wrapper: PropTypes.string,
    header: PropTypes.string,
    headerTitle: PropTypes.string,
    headerArrowUpIcon: PropTypes.string,
    headerArrowDownIcon: PropTypes.string,
    checkIcon: PropTypes.string,
    list: PropTypes.string,
    listSearchBar: PropTypes.string,
    scrollList: PropTypes.string,
    listItem: PropTypes.string,
    listItemNoResult: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  select: PropTypes.shape({ value: PropTypes.string }),
  searchable: PropTypes.shape([PropTypes.string, PropTypes.string]),
};